import { render, staticRenderFns } from "./ChatInterpretersList.vue?vue&type=template&id=71b25a12&scoped=true&"
import script from "./ChatInterpretersList.vue?vue&type=script&lang=js&"
export * from "./ChatInterpretersList.vue?vue&type=script&lang=js&"
import style0 from "./ChatInterpretersList.vue?vue&type=style&index=0&id=71b25a12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b25a12",
  null
  
)

export default component.exports